// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"75bef2da","297":"360cc805","643":"f9046461","787":"0139bd17"}[chunkId] + ".chunk.js";
};